'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _AbstractReactComponent = require('./../AbstractReactComponent');

var _AbstractReactComponent2 = _interopRequireDefault(_AbstractReactComponent);

var _reactstrap = require('reactstrap');

var _FAIcon = require('./../icon/FAIcon');

var _FAIcon2 = _interopRequireDefault(_FAIcon);

var _AbstractField2 = require('./AbstractField');

var _AbstractField3 = _interopRequireDefault(_AbstractField2);

var _Tag = require('./../tag/Tag');

var _Tag2 = _interopRequireDefault(_Tag);

var _TagItem = require('./../tag/TagItem');

var _TagItem2 = _interopRequireDefault(_TagItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Field, který umožňuje zadávat hodnoty pomocí seznamu tagů (seznam položek s křížkěm) jako seznam objektů.
 */
var ObjectTagField = function (_AbstractField) {
    (0, _inherits3.default)(ObjectTagField, _AbstractField);

    function ObjectTagField() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, ObjectTagField);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ObjectTagField.__proto__ || (0, _getPrototypeOf2.default)(ObjectTagField)).call.apply(_ref, [this].concat(args))), _this), _this.handleAddTag = function (inputValue) {
            var _this$props = _this.props,
                equalsItems = _this$props.equalsItems,
                value = _this$props.value,
                onChange = _this$props.onChange;


            var found = false;
            for (var a = 0; a < value.length; a++) {
                if (equalsItems(value[a], inputValue)) {
                    found = true;
                    break;
                }
            }

            if (!found) {
                var newValue = [].concat((0, _toConsumableArray3.default)(value), [inputValue]);

                onChange(newValue);
            }
        }, _this.handleRemoveTag = function (index) {
            var _this$props2 = _this.props,
                value = _this$props2.value,
                onChange = _this$props2.onChange;

            var newValue = [].concat((0, _toConsumableArray3.default)(value.slice(0, index)), (0, _toConsumableArray3.default)(value.slice(index + 1)));

            onChange(newValue);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(ObjectTagField, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                className = _props.className,
                getItemValue = _props.getItemValue,
                onBlur = _props.onBlur,
                value = _props.value,
                onChange = _props.onChange,
                renderTagContent = _props.renderTagContent,
                fieldComponent = _props.fieldComponent,
                fieldProps = _props.fieldProps,
                props = (0, _objectWithoutProperties3.default)(_props, ['className', 'getItemValue', 'onBlur', 'value', 'onChange', 'renderTagContent', 'fieldComponent', 'fieldProps']);

            // const field = (
            //     <Input
            //         type="text"
            //         {...props}
            //     />
            // );

            var inputField = _react2.default.createElement(fieldComponent, (0, _extends3.default)({}, fieldProps, {
                value: null,
                onChange: this.handleAddTag
            }));

            var tags = void 0;
            if (value) {
                tags = _react2.default.createElement(
                    _Tag2.default,
                    props,
                    value.map(function (v, index) {
                        return _react2.default.createElement(
                            _TagItem2.default,
                            { key: index, onRemove: function onRemove() {
                                    return _this2.handleRemoveTag(index);
                                } },
                            renderTagContent(v)
                        );
                    })
                );
            }

            return _react2.default.createElement(
                'div',
                { className: className },
                inputField,
                tags
            );
        }
    }]);
    return ObjectTagField;
}(_AbstractField3.default);

ObjectTagField.PropTypes = {
    renderTagContent: _react2.default.PropTypes.func,
    equalsItems: _react2.default.PropTypes.func // funkce (a, b) => return bool, je to funkce na porovnání dvou položek, pro docílení nemožnosti vícenásobného přiřazení položky s jedním id, pokud není uvedeno, porovnává se na ===
    // fieldComponent: React.PropTypes.element.isRequired,
    // fieldProps: React.PropTypes.element.isRequired,
};
ObjectTagField.defaultProps = {
    getItemValue: function getItemValue(i) {
        return i ? i.name : "";
    },
    equalsItems: function equalsItems(a, b) {
        return a === b;
    }
};
exports.default = ObjectTagField;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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